import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-play\"><rect width=\"32\" height=\"32\" rx=\"2\" fill=\"#fff\" fill-opacity=\".5\" /><path d=\"M11.75 21.396V10.678a.5.5 0 01.775-.418l8.789 5.788a.5.5 0 01-.03.854l-8.79 4.93a.5.5 0 01-.744-.436z\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol